"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var makeCalendarRows = function makeCalendarRows(viewDate) {
  var viewYear = viewDate.year();
  var viewMonth = viewDate.month();
  var daysInViewMonth = viewDate.daysInMonth();
  var viewMonthFirstDayOfWeek = (0, _moment["default"])(viewDate).startOf('month').day();
  var daysInPrevMonth = (0, _moment["default"])(viewDate).subtract(1, 'months').daysInMonth();
  var rows = [];
  var inPrevMonth = viewMonthFirstDayOfWeek > 0;
  var inNextMonth = false;
  var dayOfMonth = inPrevMonth ? daysInPrevMonth - viewMonthFirstDayOfWeek + 1 : 1;

  for (var row = 0; row < 6; row += 1) {
    rows[row] = [];

    for (var col = 0; col < 7; col += 1) {
      var month = viewMonth;
      var year = viewYear;

      if (inPrevMonth) {
        var prevMonthDate = (0, _moment["default"])(viewDate).subtract(1, 'months');
        year = prevMonthDate.year();
        month = prevMonthDate.month();
      }

      if (inNextMonth) {
        var nextMonthDate = (0, _moment["default"])(viewDate).add(1, 'months');
        year = nextMonthDate.year();
        month = nextMonthDate.month();
      }

      rows[row][col] = {
        year: year,
        month: month,
        dayOfMonth: dayOfMonth
      };
      dayOfMonth += 1;

      if (inPrevMonth && dayOfMonth > daysInPrevMonth) {
        dayOfMonth = 1;
        inPrevMonth = false;
      }

      if (!inPrevMonth && !inNextMonth && dayOfMonth > daysInViewMonth) {
        dayOfMonth = 1;
        inNextMonth = true;
      }
    }
  }

  return rows;
};

var _default = makeCalendarRows;
exports["default"] = _default;